import Button from '@/components/elements/Button';
import { useTranslations } from 'use-intl';
import { useNetwork } from '@/presentation/context/network';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { useModalContext } from '@/presentation/context/modal';
import { useRouter } from 'next/navigation';

const Success = ({
  // state,
  // receipt,
  vaultId,
}: {
  vaultId: string;
  // state: CreateVaultDetails;
  // receipt: TransactionReceipt;
}) => {
  const { chain, slug } = useNetwork();
  const { push } = useRouter();
  const { closeModal } = useModalContext();
  const t = useTranslations('CreateVault.Success');
  // const { data: metadata } = useCollection(state.address);
  // const { baseToken } = parseXTokenCreatedEvent(receipt?.logs);

  // console.log({ state, receipt });

  return (
    <div className="max-w-md mx-auto space-y-6">
      <div className="p-4 rounded-lg border border-gray-300 overflow-hidden bg-gray-50">
        <h2 className="text-lg text-center mb-2 font-bold">{'Success'}</h2>
        <div className="p-4 flex justify-center items-center">
          <Icon name={Icons.CHECK} size={48} className="text-green-500" />
        </div>
        <p className="text-center mb-8">{'Your position has been created.'}</p>

        <Button
          onClick={() => {
            push(`/${slug}/profile/positions`);
            closeModal();
          }}
          className="mx-auto"
        >
          {'View positions'}
        </Button>
      </div>
    </div>
  );
};

export default Success;
